import {
  LiveGame,
  formatGameStatus,
  getGameWinner,
  getInPossession,
  getTotalScores,
} from "@/utils/game";
import { ScoreboardGame, isGameClosed, isGameException } from "common";
import React from "react";
import ViewPicks from "./view-picks";
import Chip from "@/components/primitives/chip";
import Icon from "@/components/primitives/icon";

export default function GameDetailScore({
  data,
  live,
  size = "lg",
  dark,
}: {
  data: ScoreboardGame;
  live?: LiveGame;
  size?: "md" | "lg";
  dark?: boolean;
}) {
  const totalScore = getTotalScores(data.period);
  const winner = getGameWinner(data);
  const awayInPossession = getInPossession(data, "away");
  const homeInPossession = getInPossession(data, "home");
  return (
    <div className="flex justify-center flex-col items-center">
      {/* 3 COLUMN SCORE & STATUS LAYOUT */}
      <div
        className={`grid grid-cols-[minmax(60px,96px)_minmax(96px,100px)_minmax(60px,96px)] text-headline-lg xs:text-display-lg ${
          dark ? "text-white" : "text-secondary-300"
        } items-center relative ${live ? "mt-0" : "mt-6"} gap-2`}
      >
        <div className="flex justify-end items-center relative">
          {awayInPossession && (
            <div className={`bottom-8 absolute ${dark ? "fill-primary" : "fill-secondary-300"}`}>
              <Icon name="football" size="sm" />
            </div>
          )}
          {data.status !== "Scheduled" && (
            <div
              className={`flex justify-center items-center relative ${
                winner === "away" || !winner ? "opacity-100" : "opacity-60"
              }`}
            >
              {winner && winner === "away" && (
                <div className="absolute -top-6">
                  <Icon
                    name="arrow-button-down"
                    className={`${dark ? "fill-white" : "fill-dark"}`}
                  />
                </div>
              )}
              {totalScore.away}
            </div>
          )}
        </div>
        {data.status === "Scheduled" ? (
          <div className="flex justify-center">
            <ViewPicks />
          </div>
        ) : (
          <div className="flex flex-col justify-center items-center">
            <Chip
              color={
                data.status === "Suspended" || isGameException(data.status)
                  ? "white"
                  : isGameClosed(data.status)
                  ? "dark"
                  : "primary"
              }
              size={size}
            >
              <span className="normal-case">
                {live ? live.status : formatGameStatus(data)}
              </span>
            </Chip>
          </div>
        )}
        <div className="flex justify-start items-center relative">
          {data.status !== "Scheduled" && (
            <div
              className={`flex justify-center items-center relative ${
                winner === "home" || !winner ? "opacity-100" : "opacity-60"
              }`}
            >
              {winner && winner === "home" && (
                <div className="absolute -top-6">
                  <Icon
                    name="arrow-button-down"
                    className={`${dark ? "fill-white" : "fill-dark"}`}
                  />
                </div>
              )}
              {totalScore.home}
            </div>
          )}
          {homeInPossession && (
            <div className={`bottom-8 absolute ${dark ? "fill-primary" : "fill-secondary-300"}`}>
            <Icon name="football" size="sm" />
          </div>
          )}
        </div>
      </div>
    </div>
  );
}
